import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useHttp from "../../../hooks/use-http";
import { endPoints } from "../../../config/end-points";
import { useParams } from "react-router-dom";

const PollData = () => {
  const [pollData, setPollData] = useState();
  const [pollResult, setPollResult] = useState();
  const { camp_id } = useParams();
  const personalize_pollData = useSelector(
    (state) => state.personalize.personalize_pollData
  );
  const { sendRequest: fetchDataRequest } = useHttp();

  useEffect(() => {
    if (personalize_pollData) {
      setPollData(personalize_pollData);
      // console.log(personalize_pollData)
      fetchDataRequest(
        {
          url: endPoints.getPollData + "/" + camp_id,
          method: "GET",
        },
        (response) => {
          // console.log(response)
          if (response.status === 200) {
            const pollCountsData = Object.assign({},...response.data)
            setPollResult(pollCountsData);
          }
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalize_pollData]);

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-6">
          <div className="video_setting_left shadow2 bg-white p-3 h-100">
            {pollData && (
              <>
                <h3>{pollData.question}</h3>

                <ul className="custom_poll mt-2">
                  <li className=" bg-info text-light">
                    {pollData.option1}{" "}
                    {pollResult && (
                      <span className="pull-right ">
                        {pollResult.option1_count} votes
                      </span>
                    )}
                  </li>
                  <li className=" bg-info text-light">
                    {pollData.option2}{" "}
                    {pollResult && (
                      <span className="pull-right">
                        {pollResult.option2_count} votes
                      </span>
                    )}
                  </li>
                  {pollData.option3 && (
                    <li className=" bg-info text-light">
                      {pollData.option3}{" "}
                      {pollResult && (
                        <span className="pull-right">
                          {pollResult.option3_count} votes
                        </span>
                      )}
                    </li>
                  )}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PollData;
